/* =====================================================================
 * Accent — special per-phase colours used by agent workflow indicators.
 *
 * Mode-agnostic. Kept separate from palette so tenants can override
 * phase colours independently of the core accent.
 * ===================================================================== */

export const phaseColors = {
  planning: '#8b5cf6',
  execution: '#3b82f6',
  evaluation: '#f59e0b',
  refinement: '#10b981',
  final: '#10a37f',
} as const;

export type PhaseColors = typeof phaseColors;
